import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { useAuth } from '../../context/auth-context';

export function DevLogin() {
  const [email, setEmail] = useState('jaume.portell@gmail.com');
  const [name, setName] = useState('Jaume Portell');
  const [isLoading, setIsLoading] = useState(false);
  const { login, error } = useAuth();

  const handleDevLogin = async () => {
    setIsLoading(true);
    // Create a mock Google ID token for development
    const mockIdToken = btoa(JSON.stringify({
      iss: 'https://accounts.google.com',
      azp: '266296664592-35cjqmg12jn6lijp66210j3gpsc9rfit.apps.googleusercontent.com',
      aud: '266296664592-35cjqmg12jn6lijp66210j3gpsc9rfit.apps.googleusercontent.com',
      sub: '117799775500686878601', // Your Google ID
      email: email,
      email_verified: true,
      name: name,
      picture: 'https://lh3.googleusercontent.com/a/default-user',
      given_name: name.split(' ')[0],
      family_name: name.split(' ')[1] || '',
      locale: 'en',
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + 3600
    }));

    try {
      console.log('Initiating dev login for:', { email, name });
      await login('dev-bypass-' + mockIdToken);
      console.log('Dev login successful');
      // The auth context will handle navigation after state is updated
    } catch (error) {
      console.error('Dev login failed:', error);
      // Error is already set in the auth context
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle>Development Login</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Email</label>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
          />
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium">Name</label>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your Name"
          />
        </div>
        <Button onClick={handleDevLogin} className="w-full" disabled={isLoading}>
          {isLoading ? 'Logging in...' : `Login as ${name}`}
        </Button>
        {error && (
          <div className="text-sm text-destructive mt-2">
            {error}
          </div>
        )}
      </CardContent>
    </Card>
  );
}